'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint no-param-reassign: 0 */


var _pick = require('lodash/pick');

var _pick2 = _interopRequireDefault(_pick);

var _pickBy = require('lodash/pickBy');

var _pickBy2 = _interopRequireDefault(_pickBy);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _reduce2 = require('lodash/reduce');

var _reduce3 = _interopRequireDefault(_reduce2);

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _omitBy = require('lodash/omitBy');

var _omitBy2 = _interopRequireDefault(_omitBy);

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

var _constants = require('./constants');

var componentEvents = _interopRequireWildcard(_constants);

var _EventConstants = require('../models/EventConstants');

var _EventConstants2 = _interopRequireDefault(_EventConstants);

var _ControlRoomUtils = require('../utils/ControlRoomUtils');

var _ControlRoomUtils2 = _interopRequireDefault(_ControlRoomUtils);

var _componentData2 = require('../models/componentData');

var _DebugManager = require('../utils/DebugManager');

var _DebugManager2 = _interopRequireDefault(_DebugManager);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var dmInstance = _DebugManager2.default.dmInstance;
var ScreenNamesEnum = _EventConstants2.default.ScreenNamesEnum;

var EventListReducer = function () {
  function EventListReducer() {
    _classCallCheck(this, EventListReducer);
  }

  _createClass(EventListReducer, null, [{
    key: 'reduce',


    //clear all data at once since all components will be rebuilt after seek
    value: function reduce(eventModel) {
      var eventList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      if ((0, _isEmpty2.default)(eventList)) {
        return _extends({}, eventModel);
      }

      return (0, _reduce3.default)(eventList, function (updatedEventModel, _ref) {
        var _ref$payload = _ref.payload,
            payload = _ref$payload === undefined ? {} : _ref$payload;
        var type = payload.type,
            screenType = payload.screenType,
            screenId = payload.screenId,
            data = payload.data,
            componentId = payload.componentId,
            questionId = payload.questionId,
            pollId = payload.pollId,
            deleteOption = payload.deleteOption,
            surveyId = payload.surveyId,
            pageId = payload.pageId,
            order = payload.order;


        switch (type) {
          case componentEvents.CREATE_PRODUCER_SCREEN:
          case componentEvents.CREATE_AUDIENCE_SCREEN:
            {

              //clear out screens on seek
              if (updatedEventModel.resetComponents) {
                updatedEventModel = EventListReducer.clearCurrentScreenComponents(updatedEventModel);
                updatedEventModel.resetComponents = false;
              }

              var screenData = EventListReducer.getEmptyScreenModel(payload);
              var currentScreenTypeArray = updatedEventModel.screensPerType[screenType];
              updatedEventModel.screens[screenId] = _extends({}, screenData);

              // For some reason, this reducer is called twice, so to avoid duplicates for now,
              // if the screen is already in array, keep the same
              // TODO: investigate why reducer gets called twice.
              var newScreensArray = currentScreenTypeArray.includes(screenId) ? currentScreenTypeArray : [].concat(_toConsumableArray(currentScreenTypeArray), [screenId]);
              // add to screen's type array
              updatedEventModel.screensPerType[screenType] = newScreensArray;
              break;
            }
          case componentEvents.CREATE_PRODUCER_COMPONENT:
          case componentEvents.CREATE_AUDIENCE_COMPONENT:
            {
              var coordinates = data.coordinates,
                  dimensions = data.dimensions,
                  name = data.name,
                  _type = data.type,
                  classScope = data.classScope,
                  componentData = data.componentData;

              //clear out all screen components and component data on seek

              if (updatedEventModel.resetComponents) {
                updatedEventModel = EventListReducer.clearComponentData(updatedEventModel);
                updatedEventModel = EventListReducer.clearCurrentScreenComponents(updatedEventModel);
                updatedEventModel.resetComponents = false;
              }
              /**
               * add the coordinate, dimensions to the screen[screenId].components
               * store the data itself in the components of the redux store
               * First check to see if screen exists - WN-3620
               */
              if (EventListReducer.screenExists(updatedEventModel.screens, screenId, componentId)) {
                var matchingScreen = updatedEventModel.screens[screenId];
                matchingScreen.components[componentId] = {
                  id: componentId,
                  type: _type,
                  dimensions: dimensions,
                  coordinates: coordinates
                };
                updatedEventModel.components[componentId] = {
                  name: name,
                  type: _type,
                  id: componentId,
                  classScope: classScope,
                  data: componentData || {}
                };

                // WN-2972 - need to force av component to front of the line

                var currentComponentArray = Object.entries(matchingScreen.components);
                var i = currentComponentArray.findIndex(function (item) {
                  return item[0].includes('av');
                });

                if (i !== -1) {
                  currentComponentArray.unshift(currentComponentArray.splice(i, 1)[0]);
                }

                matchingScreen.components = Object.fromEntries(currentComponentArray);
              }

              break;
            }
          case componentEvents.EDIT_PRODUCER_COMPONENT:
          case componentEvents.EDIT_AUDIENCE_COMPONENT:
            {
              if (EventListReducer.componentExists(updatedEventModel.components, data.id, type) && EventListReducer.screenExists(updatedEventModel.screens, screenId, data.id)) {
                var _matchingScreen = updatedEventModel.screens[screenId];
                var screenComponent = _matchingScreen.components[data.id];

                // note: sometimes we make it into this conditional and
                // screenComponent is undefined.. probably a bug

                _matchingScreen.components[data.id] = _extends({}, _matchingScreen.components[data.id], {
                  coordinates: data.coordinates,
                  dimensions: _extends({}, screenComponent ? screenComponent.dimensions : {}, data.dimensions)
                });

                if (!(0, _isUndefined2.default)(data.name)) {
                  updatedEventModel.components[data.id].name = data.name;
                }
              }
              break;
            }
          case componentEvents.VIDEO_SENTIMENT_TRACKING:
            {
              if (EventListReducer.componentExists(updatedEventModel.components, data.id, type)) {
                var matchingComp = updatedEventModel.components[data.id];
                matchingComp.sentimentTracking = data.sentimentTracking;
              }
              updatedEventModel.sentimentTracking = data.sentimentTracking;
              break;
            }
          case componentEvents.VIDEO_DELIVERY_OPTION:
            {
              if (EventListReducer.componentExists(updatedEventModel.components, data.id, type)) {
                updatedEventModel.components[data.id].deliveryOption = data.deliveryOption;
              }
              updatedEventModel.deliveryOption = data.deliveryOption;
              break;
            }
          case componentEvents.EDIT_VIDEO_TYPE:
            {
              if (EventListReducer.componentExists(updatedEventModel.components, data.id, type)) {
                updatedEventModel.components[data.id].videoType = data.videoType;
              }
              updatedEventModel.videoType = data.videoType;
              break;
            }

          case componentEvents.PRERECORDED_SET_VOD_DATA:
            {
              if (updatedEventModel.prerecordedVideo) {
                updatedEventModel.prerecordedVideo = _extends({}, updatedEventModel.prerecordedVideo, data);
              }
              break;
            }

          case componentEvents.PRERECORDED_FILE_STATUS_CHANGE_PRODUCER:
            {
              if (updatedEventModel.prerecordedVideo) {
                updatedEventModel.prerecordedVideo.fileStatus = data.fileStatus;
              }
              break;
            }

          case componentEvents.PRERECORDED_RESET_VIDEO_PRODUCER:
            {
              if (updatedEventModel.prerecordedVideo) {
                updatedEventModel.prerecordedVideo = data;
              }
              break;
            }

          case componentEvents.DELETE_PRODUCER_COMPONENT:
          case componentEvents.DELETE_AUDIENCE_COMPONENT:
            {
              // reducer is called twice for some reason
              if (EventListReducer.componentExists(updatedEventModel.components, componentId, type)) {
                var _classScope = updatedEventModel.components[componentId].classScope;
                // check classScope, if mulitple or screen delete from components obj
                if (!(0, _isUndefined2.default)(_classScope) && _classScope !== 'singleton') {
                  var pickedComponents = (0, _pickBy2.default)(updatedEventModel.components, function (component) {
                    return component.id !== componentId;
                  });
                  updatedEventModel.components = pickedComponents;
                }

                if (EventListReducer.screenExists(updatedEventModel.screens, screenId, componentId)) {
                  var _matchingScreen2 = updatedEventModel.screens[screenId];
                  // remove this component from the components object for its screen
                  delete _matchingScreen2.components[componentId];
                }
              }
              break;
            }
          case componentEvents.DELETE_PRODUCER_SCREEN:
          case componentEvents.DELETE_AUDIENCE_SCREEN:
            {
              if (!updatedEventModel.screens[screenId]) {
                break;
              }
              // Delete the components that belonged to this screen from the components object
              // grab the ids of the components in screens that aren't singleton
              // map through updatedEventModel.components and delete by id
              var _componentData = [];
              (0, _map2.default)(updatedEventModel.screens[screenId].components, function (screenComp) {
                var picked = (0, _pickBy2.default)(updatedEventModel.components, function (component) {
                  return component.id === screenComp.id;
                });
                if (picked[screenComp.id].classScope !== 'singleton') {
                  _componentData.push(Object.keys(picked).toString());
                }
              });
              updatedEventModel.components = (0, _omit2.default)(updatedEventModel.components, _componentData);

              var indexOfScreenId = updatedEventModel.screensPerType[screenType].indexOf(screenId);
              // remove the screen from the screens object AND the screensPerType object
              updatedEventModel.screens = (0, _omit2.default)(updatedEventModel.screens, screenId);
              if (indexOfScreenId > -1) {
                updatedEventModel.screensPerType[screenType].splice(indexOfScreenId, 1);
              }
              break;
            }
          case componentEvents.EDIT_AUDIENCE_SCREEN:
          case componentEvents.EDIT_PRODUCER_SCREEN:
            {
              if (EventListReducer.screenExists(updatedEventModel.screens, screenId)) {
                updatedEventModel.screens[screenId].title = data.title;
              }
              break;
            }
          case componentEvents.UPDATE_SCREEN_LOCK:
            {
              if (EventListReducer.screenExists(updatedEventModel.screens, screenId)) {
                var screen = updatedEventModel.screens[screenId];
                updatedEventModel.screens[screenId] = _extends({}, screen, {
                  lockedOwner: data.lockedOwner,
                  isLocked: data.isLocked
                });
              }
              break;
            }
          case componentEvents.UPDATE_ACTIVE_AUDIENCE_SCREEN:
            {
              // TODO stub this action
              updatedEventModel.activeAudienceScreenId = screenId;
              break;
            }
          case componentEvents.CREATE_QUESTION:
            {
              updatedEventModel.qaQuestions = updatedEventModel.qaQuestions || {};
              updatedEventModel.qaQuestions[data.question.id] = data.question;
              break;
            }
          case componentEvents.EDIT_QUESTION:
            {
              var previousData = updatedEventModel.qaQuestions[questionId];
              updatedEventModel.qaQuestions[questionId] = _extends({}, previousData, data);
              break;
            }
          case componentEvents.CREATE_SURVEY:
            {
              updatedEventModel.surveyList[data.survey.id] = _extends({}, data.survey);
              break;
            }
          case componentEvents.CREATE_SURVEY_PAGE:
            {
              var survey = updatedEventModel.surveyList[surveyId];
              if (!(0, _isEmpty2.default)(survey)) {
                var currentPages = survey.pages;
                updatedEventModel.surveyList[surveyId].pages = _extends({}, currentPages, { pageId: { order: order, questions: {} } });
              } else {
                console.warn('Ignoring ' + type + ' because survey: ' + surveyId + ' doesn\'t exist');
              }
              break;
            }
          case componentEvents.EDIT_SURVEY:
          case componentEvents.EDIT_SURVEY_NAME:
            {
              var _survey = updatedEventModel.surveyList[surveyId];

              var newSurvey = _extends({}, _survey, data);

              updatedEventModel.surveyList[surveyId] = newSurvey;

              break;
            }
          case componentEvents.DELETE_SURVEY:
            {
              updatedEventModel.surveyList = (0, _omitBy2.default)(updatedEventModel.surveyList, function (survey) {
                return survey.id === data.id;
              });
              break;
            }
          case componentEvents.ACTIVE_SURVEY:
            {
              updatedEventModel.surveyActiveId = data;
              updatedEventModel.surveyAudiencePageId = pageId;
              break;
            }
          case componentEvents.SUBMIT_SURVEY:
            {
              var surveyData = _extends({}, updatedEventModel.surveyList[surveyId]);

              if ((0, _isEmpty2.default)(surveyData)) {
                console.warn('Ignoring ' + type + ' because survey: ' + surveyId + ' doesn\'t exist');
                break;
              }

              Object.values(surveyData.pages).forEach(function (page) {
                var questions = page.questions;

                Object.entries(data.selectedAnswers).forEach(function (q) {
                  var qId = q[0];
                  var answers = q[1];
                  var question = questions[qId];
                  if ((0, _isUndefined2.default)(question.submissions)) {
                    question.submissions = 0;
                  }
                  if (qId === question.id) {
                    question.submissions += Object.keys(answers).length;
                    Object.keys(answers).forEach(function (answerId) {
                      if (!(0, _isUndefined2.default)(question.answers[answerId])) {
                        if ((0, _isUndefined2.default)(question.answers[answerId].count)) {
                          question.answers[answerId].count = 0;
                        }
                        question.answers[answerId].count += 1;
                        if ((0, _isUndefined2.default)(surveyData.submissions)) {
                          surveyData.submissions = 0;
                        }
                        surveyData.submissions += 1;
                      }
                    });
                  }
                });
              });
              updatedEventModel.surveyList[surveyId] = surveyData;
              break;
            }
          case componentEvents.REVEAL_SURVEY:
            {
              if (!(0, _isUndefined2.default)(updatedEventModel.surveyList[surveyId])) {
                var _survey2 = updatedEventModel.surveyList[surveyId];
                var _newSurvey = _extends({}, _survey2, data);
                updatedEventModel.surveyList[surveyId] = _newSurvey;
              }
              break;
            }
          case componentEvents.CREATE_POLL:
            {
              updatedEventModel.pollList[data.poll.id] = _extends({}, data.poll);
              break;
            }
          case componentEvents.EDIT_POLL:
          case componentEvents.EDIT_POLL_NAME:
            {
              var poll = updatedEventModel.pollList[pollId];

              var newPoll = _extends({}, poll, data, {
                id: pollId
              });

              updatedEventModel.pollList[pollId] = newPoll;

              break;
            }
          case componentEvents.REVEAL_POLL:
            {
              if (!(0, _isUndefined2.default)(updatedEventModel.pollList[pollId])) {
                var _poll = updatedEventModel.pollList[pollId];
                var _newPoll = _extends({}, _poll, {
                  revealPollOption: data.revealOption,
                  answersPercentage: data.percentData
                });
                updatedEventModel.pollList[pollId] = _newPoll;
              }
              break;
            }
          case componentEvents.ACTIVE_POLL:
            {
              updatedEventModel.pollActiveId = data;
              break;
            }
          case componentEvents.DELETE_POLL:
            {
              updatedEventModel.pollList = (0, _omitBy2.default)(updatedEventModel.pollList, function (poll) {
                return poll.id === data.id;
              });
              break;
            }
          case componentEvents.SUBMIT_POLL:
            {
              var pollData = updatedEventModel.pollList[pollId];
              if (!pollData) break;
              pollData.answerSubmitted = true;

              if ((0, _isEmpty2.default)(pollData.submissions)) {
                pollData.submissions = [];
              }
              pollData.submissions.push(data.selectedAnswerId);

              break;
            }

          case componentEvents.CREATE_FOLDER:
            {
              updatedEventModel.qaFolders = updatedEventModel.qaFolders || {};
              updatedEventModel.qaFolders[data.folder.id] = data.folder;
              break;
            }
          case componentEvents.EDIT_FOLDER:
            {
              if (!(0, _isEmpty2.default)(updatedEventModel.qaFolders[data.folder.id])) {
                updatedEventModel.qaFolders[data.folder.id].name = data.folder.name;
              } else {
                console.warn('Ignoring ' + type + ' because folder: ' + data.folder.id + ' doesn\'t exist');
              }
              break;
            }
          case componentEvents.DELETE_FOLDER:
            {
              updatedEventModel.qaFolders = (0, _omitBy2.default)(updatedEventModel.qaFolders, function (folder) {
                return folder.id === data.id;
              });
              break;
            }
          case componentEvents.EDIT_SCREEN_ORDER:
            {
              var moving = payload.moving,
                  moveTo = payload.moveTo,
                  oldScreenOrder = payload.oldScreenOrder;
              // if the screens have already been reordered, exit

              if (!(0, _isEqual2.default)(oldScreenOrder, updatedEventModel.screensPerType[screenType])) {
                break;
              }

              updatedEventModel.screensPerType[screenType] = _ControlRoomUtils2.default.reorderArray(updatedEventModel.screensPerType[screenType], moving, moveTo);
              break;
            }
          case componentEvents.EDIT_COMPONENT_ORDER:
            {
              var _moving = payload.moving,
                  _moveTo = payload.moveTo,
                  oldComponentOrder = payload.oldComponentOrder;

              if (EventListReducer.screenExists(updatedEventModel.screens, screenId, 'moving: ' + _moving + 'moveTo: ' + _moveTo)) {
                // if the components have already been reordered, exit
                if (!(0, _isEqual2.default)(oldComponentOrder, Object.keys(updatedEventModel.screens[screenId].components))) {
                  break;
                }

                var componentsOrderArray = _ControlRoomUtils2.default.reorderArray(Object.keys(updatedEventModel.screens[screenId].components), _moving, _moveTo);
                updatedEventModel.screens[screenId].components = (0, _pick2.default)(updatedEventModel.screens[screenId].components, componentsOrderArray);
              }
              break;
            }
          /**
           * DEPRECATED:
           * ADD_SLIDESHOW_PDF_URL and ADD_SLIDESHOW_PDF_FILE_NAME events 
           * have been deprecated in favor of one event ADD_SLIDESHOW_PDF.
           * 
           * TODO: Need to refactor and add some sort of 
           * event translation to support older events
           */
          case componentEvents.ADD_SLIDESHOW_PDF_URL:
            {
              updatedEventModel.slideshow.pdfURL = data.pdfURL;
              break;
            }
          case componentEvents.ADD_SLIDESHOW_PDF_FILE_NAME:
            {
              updatedEventModel.slideshow.fileName = data.fileName;
              break;
            }
          /**/
          case componentEvents.ADD_SLIDESHOW_PDF:
            {
              updatedEventModel.slideshow.pdfURL = data.pdfURL;
              updatedEventModel.slideshow.fileName = data.fileName;
              break;
            }
          case componentEvents.SLIDESHOW_PDF_UPLOADING:
            {
              updatedEventModel.slideshow.isUploading = data.isUploading;
              break;
            }
          case componentEvents.UPDATE_SLIDESHOW_INDEX:
            {
              dmInstance.logMessage([_DebugManager2.default.debugLevel.COMPONENT_SLIDESHOW], '[EventListReducer] reduce() UPDATE_SLIDESHOW_INDEX: ' + data.currentIndex);
              updatedEventModel.slideshow.currentIndex = data.currentIndex;
              break;
            }
          case componentEvents.RESET_SLIDESHOW_TO_DEFAULT:
            {
              updatedEventModel.slideshow.pdfURL = data.pdfURL;
              updatedEventModel.slideshow.fileName = data.fileName;
              updatedEventModel.slideshow.currentIndex = data.currentIndex;
              updatedEventModel.slideshow.isUploading = data.isUploading;
              updatedEventModel.slideshow.ratio = data.ratio;
              break;
            }
          case componentEvents.SLIDESHOW_RATIO_COMPUTED:
            {
              var _data$ratio = data.ratio,
                  ratio = _data$ratio === undefined ? {} : _data$ratio;


              updatedEventModel.slideshow.ratio.widthRatio = ratio.widthRatio;
              updatedEventModel.slideshow.ratio.heightRatio = ratio.heightRatio;
              break;
            }
          case componentEvents.CHANGE_EVENT_STATUS:
            {
              /** Currently, we only have CHANGE_EVENT_STATUS being called when starting
               * and ending an event, so the status needs to be set to RUNNING or COMPLETE
               * to properly reflect the status being used in the controlRoom
               */
              if (data.live) {
                updatedEventModel.eventStatus = componentEvents.EventStatusEnum.RUNNING;
                updatedEventModel.eventStartTime = data.startTime;
              } else {
                updatedEventModel.eventStatus = componentEvents.EventStatusEnum.COMPLETED;
              }
              break;
            }
          case componentEvents.UPDATE_AUDIENCE_TEXTBOX:
          case componentEvents.UPDATE_PRODUCER_TEXTBOX:
            {
              if (EventListReducer.componentExists(updatedEventModel.components, componentId, type)) {
                updatedEventModel.components[componentId] = _extends({}, updatedEventModel.components[componentId], {
                  data: _extends({}, updatedEventModel.components[componentId].data, {
                    text: data.text
                  })
                });
              }
              break;
            }
          case componentEvents.UPDATE_PRODUCER_STICKY_ASPECT_STATUS:
          case componentEvents.UPDATE_AUDIENCE_STICKY_ASPECT_STATUS:
            {
              if (EventListReducer.componentExists(updatedEventModel.components, componentId, type)) {
                updatedEventModel.components[componentId] = _extends({}, updatedEventModel.components[componentId], {
                  data: _extends({}, updatedEventModel.components[componentId].data, {
                    isAspectRatioOn: data.isAspectRatioOn
                  })
                });
              }
              break;
            }
          case componentEvents.UPDATE_PRODUCER_STICKY_SIZE:
          case componentEvents.UPDATE_AUDIENCE_STICKY_SIZE:
            {
              if (EventListReducer.componentExists(updatedEventModel.components, componentId, type)) {
                updatedEventModel.components[componentId] = _extends({}, updatedEventModel.components[componentId], {
                  data: _extends({}, updatedEventModel.components[componentId].data, {
                    size: data.size
                  })
                });
              }
              break;
            }
          case componentEvents.CHANGE_IFRAME_URL_PRODUCER:
          case componentEvents.CHANGE_IFRAME_URL_AUDIENCE:
            {
              if (EventListReducer.componentExists(updatedEventModel.components, componentId, type)) {
                updatedEventModel.components[componentId] = _extends({}, updatedEventModel.components[componentId], {
                  data: _extends({}, updatedEventModel.components[componentId].data, {
                    url: data.url
                  })
                });
              }
              break;
            }
          case componentEvents.CHANGE_IFRAME_PARAMS_PRODUCER:
          case componentEvents.CHANGE_IFRAME_PARAMS_AUDIENCE:
            {
              if (EventListReducer.componentExists(updatedEventModel.components, componentId, type)) {
                updatedEventModel.components[componentId] = _extends({}, updatedEventModel.components[componentId], {
                  data: _extends({}, updatedEventModel.components[componentId].data, {
                    userDataParams: data.userDataParams
                  })
                });
              }
              break;
            }
          case componentEvents.UPDATE_MEETING_PULSE_PRODUCER:
          case componentEvents.UPDATE_MEETING_PULSE_AUDIENCE:
            {
              if (EventListReducer.componentExists(updatedEventModel.components, componentId, type)) {
                updatedEventModel.components[componentId] = _extends({}, updatedEventModel.components[componentId], {
                  data: _extends({}, updatedEventModel.components[componentId].data, {
                    meetingPulseId: data.meetingPulseId
                  })
                });
              }
              break;
            }
          case componentEvents.ADD_IMAGE_URL_PRODUCER:
          case componentEvents.ADD_IMAGE_URL_AUDIENCE:
            {
              if (EventListReducer.componentExists(updatedEventModel.components, componentId, type)) {
                updatedEventModel.components[componentId] = _extends({}, updatedEventModel.components[componentId], {
                  data: _extends({}, updatedEventModel.components[componentId].data, {
                    url: data.url,
                    fileName: data.fileName,
                    isLoading: data.isLoading
                  })
                });
              }
              break;
            }
          case componentEvents.CHANGE_IMAGE_LINK_PRODUCER:
          case componentEvents.CHANGE_IMAGE_LINK_AUDIENCE:
            {
              if (EventListReducer.componentExists(updatedEventModel.components, componentId, type)) {
                updatedEventModel.components[componentId] = _extends({}, updatedEventModel.components[componentId], {
                  data: _extends({}, updatedEventModel.components[componentId].data, {
                    link: data.link
                  })
                });
              }
              break;
            }
          case componentEvents.TOGGLE_DROP_SHADOW_PRODUCER:
          case componentEvents.TOGGLE_DROP_SHADOW_AUDIENCE:
            {
              if (EventListReducer.componentExists(updatedEventModel.components, componentId, type)) {
                updatedEventModel.components[componentId] = _extends({}, updatedEventModel.components[componentId], {
                  data: _extends({}, updatedEventModel.components[componentId].data, {
                    dropShadow: data.dropShadow
                  })
                });
              }
              break;
            }
          case componentEvents.TOGGLE_ROUNDED_CORNERS_PRODUCER:
          case componentEvents.TOGGLE_ROUNDED_CORNERS_AUDIENCE:
            {
              if (EventListReducer.componentExists(updatedEventModel.components, componentId, type)) {
                updatedEventModel.components[componentId] = _extends({}, updatedEventModel.components[componentId], {
                  data: _extends({}, updatedEventModel.components[componentId].data, {
                    roundedCorners: data.roundedCorners
                  })
                });
              }
              break;
            }
          case componentEvents.TOGGLE_TRANSPARENT_BACKGROUND_PRODUCER:
          case componentEvents.TOGGLE_TRANSPARENT_BACKGROUND_AUDIENCE:
            {
              if (EventListReducer.componentExists(updatedEventModel.components, componentId, type)) {
                updatedEventModel.components[componentId] = _extends({}, updatedEventModel.components[componentId], {
                  data: _extends({}, updatedEventModel.components[componentId].data, {
                    transparentBackground: data.transparentBackground
                  })
                });
              }
              break;
            }
          case componentEvents.CUSTOMIZE_QA_FIELDS_PRODUCER:
          case componentEvents.CUSTOMIZE_QA_FIELDS_AUDIENCE:
            {
              if (EventListReducer.componentExists(updatedEventModel.components, componentId, type)) {
                updatedEventModel.components[componentId] = _extends({}, updatedEventModel.components[componentId], {
                  data: _extends({}, updatedEventModel.components[componentId].data, data)
                });
              }
              break;
            }
          case componentEvents.CUSTOMIZE_TIMER_COMPONENT:
            {
              if (EventListReducer.componentExists(updatedEventModel.components, componentId, type)) {
                updatedEventModel.components[componentId] = _extends({}, updatedEventModel.components[componentId], {
                  data: _extends({}, updatedEventModel.components[componentId].data, data)
                });
              }
              break;
            }
          case componentEvents.CREATE_SMARTBRIDGE_SESSION:
            {
              updatedEventModel.smartBridge = data.smartBridge;
              break;
            }
          case componentEvents.SET_NAME_VISIBILITY_PRODUCER:
            {
              if (EventListReducer.componentExists(updatedEventModel.components, componentId, type)) {
                updatedEventModel.components[componentId] = _extends({}, updatedEventModel.components[componentId], {
                  data: _extends({}, updatedEventModel.components[componentId].data, {
                    hideName: data.hideName
                  })
                });
              }
              break;
            }
          case componentEvents.SET_TIMESTAMP_VISIBILITY_PRODUCER:
            {
              if (EventListReducer.componentExists(updatedEventModel.components, componentId, type)) {
                updatedEventModel.components[componentId] = _extends({}, updatedEventModel.components[componentId], {
                  data: _extends({}, updatedEventModel.components[componentId].data, {
                    hideTimestamp: data.hideTimestamp
                  })
                });
              }
              break;
            }
          case componentEvents.SET_PRIMARY_BACKGROUND_COLOR_PRODUCER:
            {
              if (EventListReducer.componentExists(updatedEventModel.components, componentId, type)) {
                updatedEventModel.components[componentId] = _extends({}, updatedEventModel.components[componentId], {
                  data: _extends({}, updatedEventModel.components[componentId].data, {
                    backgroundColor: data.backgroundColor
                  })
                });
              }
              break;
            }
          case componentEvents.SET_SECONDARY_BACKGROUND_COLOR_PRODUCER:
            {
              if (EventListReducer.componentExists(updatedEventModel.components, componentId, type)) {
                updatedEventModel.components[componentId] = _extends({}, updatedEventModel.components[componentId], {
                  data: _extends({}, updatedEventModel.components[componentId].data, {
                    secondaryBackgroundColor: data.secondaryBackgroundColor
                  })
                });
              }
              break;
            }
          case componentEvents.SET_PRIMARY_TEXT_COLOR_PRODUCER:
          case componentEvents.SET_PRIMARY_TEXT_COLOR_AUDIENCE:
            {
              if (EventListReducer.componentExists(updatedEventModel.components, componentId, type)) {
                updatedEventModel.components[componentId] = _extends({}, updatedEventModel.components[componentId], {
                  data: _extends({}, updatedEventModel.components[componentId].data, {
                    textColor: data.textColor
                  })
                });
              }
              break;
            }
          case componentEvents.SET_FONT_SIZE_PRODUCER:
            {
              if (EventListReducer.componentExists(updatedEventModel.components, componentId, type)) {
                updatedEventModel.components[componentId] = _extends({}, updatedEventModel.components[componentId], {
                  data: _extends({}, updatedEventModel.components[componentId].data, {
                    fontSize: data.fontSize
                  })
                });
              }
              break;
            }
          case componentEvents.SET_SELECTED_FOLDER_PRODUCER:
            {
              if (EventListReducer.componentExists(updatedEventModel.components, componentId, type)) {
                updatedEventModel.components[componentId] = _extends({}, updatedEventModel.components[componentId], {
                  data: _extends({}, updatedEventModel.components[componentId].data, {
                    selectedFolder: data.selectedFolder
                  })
                });
              }
              break;
            }
          case componentEvents.SET_COUNTDOWN_DATA:
            {
              updatedEventModel.countdown = _extends({}, updatedEventModel.countdown, data);
              break;
            }
          case componentEvents.SET_START_DATE_VISIBILITY:
            {
              if (EventListReducer.componentExists(updatedEventModel.components, componentId, type)) {
                updatedEventModel.components[componentId] = _extends({}, updatedEventModel.components[componentId], {
                  data: _extends({}, updatedEventModel.components[componentId].data, {
                    showStartDate: data.showStartDate
                  })
                });
              }
              break;
            }
          case componentEvents.TOGGLE_EMAIL_FORWARDING:
            {
              if (EventListReducer.componentExists(updatedEventModel.components, componentId, type)) {
                updatedEventModel.components[componentId] = _extends({}, updatedEventModel.components[componentId], {
                  data: _extends({}, updatedEventModel.components[componentId].data, {
                    qaForwardingActive: data.qaForwardingActive
                  })
                });
              }
              break;
            }
          case componentEvents.TOGGLE_INCLUDE_USER_INFO:
            {
              if (EventListReducer.componentExists(updatedEventModel.components, componentId, type)) {
                updatedEventModel.components[componentId] = _extends({}, updatedEventModel.components[componentId], {
                  data: _extends({}, updatedEventModel.components[componentId].data, {
                    includeUserInfoInEmail: data.includeUserInfoInEmail
                  })
                });
              }
              break;
            }
          default:
            {
              break;
            }
        }

        return updatedEventModel;
      }, _extends({}, eventModel));
    }

    //clear out all components except for AV component

  }]);

  return EventListReducer;
}();

EventListReducer.getEmptyScreenModel = function (_ref2) {
  var screenType = _ref2.screenType,
      screenId = _ref2.screenId,
      isDefaultScreen = _ref2.isDefaultScreen,
      title = _ref2.title;

  var defaultTitle = void 0;
  if (title) {
    defaultTitle = title;
  } else {
    switch (screenType) {
      case 'lobby':
        defaultTitle = isDefaultScreen === true ? ScreenNamesEnum.LOBBY_NAME.default : ScreenNamesEnum.LOBBY_NAME.standard;
        break;
      case 'exit':
        defaultTitle = ScreenNamesEnum.EXIT_NAME.default;
        break;
      case 'event':
        defaultTitle = isDefaultScreen === true ? ScreenNamesEnum.EVENT_NAME.default : ScreenNamesEnum.EVENT_NAME.standard;
        break;
      case 'teamView':
        defaultTitle = isDefaultScreen === true ? ScreenNamesEnum.TEAM_VIEW_NAME.default : ScreenNamesEnum.TEAM_VIEW_NAME.standard;
        break;
      default:
        defaultTitle = 'Default Layout';
        break;
    }
  }

  return {
    screenType: screenType,
    components: {},
    id: screenId,
    title: defaultTitle
  };
};

EventListReducer.clearComponentData = function (updatedEventModel) {
  updatedEventModel.polls = (0, _componentData2.polls)();
  updatedEventModel.qa = (0, _componentData2.qa)();
  updatedEventModel.surveys = (0, _componentData2.surveys)();
  updatedEventModel.slideshow = (0, _componentData2.slideshow)();

  return updatedEventModel;
};

EventListReducer.clearCurrentScreenComponents = function (em) {
  if ((0, _isEmpty2.default)(em.screens)) return em;

  Object.keys(em.screens).forEach(function (scr) {
    Object.keys(em.screens[scr].components).forEach(function (component) {
      if (em.screens[scr].components[component].type !== "av") {
        delete em.screens[scr].components[component];
      }
    });
  });
  return em;
};

EventListReducer.componentExists = function (components, componentId, type) {
  // Component events could come in out of order due to being in a distributed environment,
  // e.g. an edit action could follow a delete action for the same component when not on a websocket.
  // Because of this, we first need to check the components list for existence
  if (components && components[componentId]) {
    return true;
  } else {
    console.warn('Ignoring ' + type + ' because component: ' + componentId + ' no longer exists');
    return false;
  }
};

EventListReducer.screenExists = function (screens, screenId, componentId) {
  if (screens && screens[screenId]) {
    return true;
  } else {
    console.warn('Ignoring ' + screenId + ' as it no longer exists');
    console.warn('Related Component Id: ' + componentId);
    return false;
  }
};

exports.default = EventListReducer;